import importerActions from 'src/modules/shared/importer/importerActions';
import selectors from 'src/modules/appUser/importer/appUserImporterSelectors';
import AppUserService from 'src/modules/appUser/appUserService';
import fields from 'src/modules/appUser/importer/appUserImporterFields';
import { i18n } from 'src/i18n';

const appUserImporterActions = importerActions(
  'APPUSER_IMPORTER',
  selectors,
  AppUserService.import,
  fields,
  i18n('entities.appUser.importer.fileName'),
);

export default appUserImporterActions;